<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button hide-settings>
      <template #beforeDropdown>
        <b-button variant="primary" class="btn-icon mx-1" v-b-tooltip v-bind:title="$t('columns.self')"
                  @click="openColumnsModal">
          <i class="fa-solid fa-bars"></i>
        </b-button>
      </template>
    </breadcrumb-button>
    <!--Filters-->
    <filter-card v-model="filter" v-bind:fields="filterFields" search />
    <!--Table Card-->
    <b-card no-body>
      <b-card-header class="pb-50 d-flex">
        <h5>{{ $t('menu.account') }}</h5>
<!--        <div>
          <transaction-toggle class="mb-1" v-model="transactionType"/>
        </div>-->
      </b-card-header>
      <b-card-body>
        <account-table ref="accountTable" v-bind:filters="filter" v-bind:columns="columns" :has-selection="false"
                       :lazy="true" @selected="openAccountModal"
                       :trans-type="transactionType">
          <template #table-top-actions="{selectedIds}">
            <div>
              <b-button size="sm" class="mb-1 mr-1 client-action-button" variant="outline-primary"
                        @click="openMassOrder(selectedIds)">
                <i class="fa-solid fa-arrows-rotate"></i> &nbsp; &nbsp;
                <span class="description">{{ $t('operations.openMassOrder') }}</span>
              </b-button>
            </div>
          </template>
        </account-table>
      </b-card-body>
    </b-card>
    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="account" v-model="columns"
                   v-bind:columns-names="columnsNames"
    />
    <account-modal ref="account-modal"  @close="refreshTables"/>
    <trade-mass-oder-modal ref="trade-mass-order-modal" @close="refreshTables"/>

  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import BreadcrumbButton from '@/components/widget/breadcrumbButton';
import AccountSearchRequest from '@/model/account/AccountSearchRequest';
import ColumnsModal from '@/components/modal/columnsModal';
import Account from '@/model/account/Account';
import mixinPermissions from '@/components/mixin/mixinPermissions';
import mixinBase from '@/components/mixin/mixinBase';
import FilterCard from '@/components/widget/FilterCard';
import AccountFilterFields from '@/model/filter/AccountFilterFields';
import AccountTable from '@/components/tables/AccountTable';
import AccountModal from '@/components/modal/AccountModal.vue'
import TradeMassOderModal from '@/components/modal/tradeMassOderModal.vue'

export default {
  name: 'AccountView',
  components: {
    TradeMassOderModal,
    AccountModal,
    AccountTable,
    FilterCard,
    ColumnsModal,
    BreadcrumbButton,
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {

      transactionType: 'deposits',
      columnsNames: Object.keys(Account()),
      filter: AccountSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    };
  },
  watch: {

  },
  async created() {
    this.filterFields = AccountFilterFields()
        .filter(field => field.permission == null || this.hasPermission(field.permission));
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('account', ['']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal();
    },
    openAccountModal(account){
      console.log("openAccountModal", account)
      this.$refs['account-modal'].showModal(account);
    },
    openMassOrder(selectedIds){
      this.$refs['accountTable'].toggleAllRow(false)
      this.$refs['trade-mass-order-modal'].showModal(selectedIds);
    }
  }
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
  height: 10px;
}
</style>
